const getRootDomain = (url: string) => {
  if (!import.meta.env.PROD) {
    return location.hostname
  }
  const apiHostname = url
  if (apiHostname) {
    const parts = apiHostname.split(".")
    return parts.slice(-2).join(".")
  }
}

export const getApiRootDomain = () =>
  getRootDomain(import.meta.env.VITE_API_GATEWAY_2_URL)

export const getWebsiteRootDomain = () =>
  getRootDomain(import.meta.env.VITE_PUBLIC_WEBSITE_URL)
